<div class="app-dialog-checkbox" [ngClass]="{ notitle: !data.title }">
  <h5 *ngIf="data.title" mat-dialog-title class="app-dialog-checkbox__title">
    {{ data.title }}
  </h5>
  <div mat-dialog-content class="app-dialog-checkbox__content">
    <span [innerHTML]="data.content | safeHtml"></span>
  </div>

  <div mat-dialog-content class="app-dialog-checkbox__control">
    <app-checkbox
      [formControl]="checkboxControl"
      [label]="data.checkboxText"
      [noPaddingLeft]="true"
    ></app-checkbox>
  </div>

  <div mat-dialog-actions class="app-dialog-checkbox__actions">
    <app-button
      [size]="btnSizes.FullWidth"
      [type]="item === 'ok' || item === 'yes' ? btnTypes.Flat : btnTypes.Stroked"
      (click)="close(item)"
      *ngFor="let item of data.actionsKeys"
      [label]="getLabel(item)"
      class="app-dialog-checkbox__action"
    ></app-button>
    <div style="display: none" cdkFocusInitial></div>
  </div>
</div>
